import React from 'react';
import './HeadingWithDetails.scss';
import Enemies from '../Enemies';
import Details from '../Details';
const HeadingWithDetails = ({ actions, breadcrumb,  status, headline, items, style, toast, filedIn }) => (
  <div className="heading-with-details">
    {style && (
      <div
        className="heading-with-details__image"
        style={style}
      />
    )}
    <div className="heading-with-details__wrapper">
      {breadcrumb && (
        <div className="heading-with-details__breadcrumb">
          {breadcrumb}
        </div>
      )}
      <div className={status === "On Hold" ? "heading-with-details__body-yellow" : "heading-with-details__body"}>
        {toast && (
          <div className="heading-with-details__top">
            {toast}
          </div>
        )}
        <div className="heading-with-details__bottom">
          <Enemies>
            {headline && (
              <div className="heading-with-details__headline">
                {headline}
              </div>
            )}
            </Enemies>
            {
              filedIn && (
                <div>
                 Filed in: {filedIn}
                </div>
              )
            }
            {actions && (
              <div className="heading-with-details__actions">
                {actions}
              </div>
            )}
          <div className="heading-with-details__details">
            <Details items={items.filter(item=>item)} />
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default HeadingWithDetails;
